import { useEffect, useState } from 'react'
import { GameBus } from '@game/core/GameBus'
import type { GameBusEvents } from '@shared/types'

// Hook genérico: assina um evento do GameBus e devolve o último valor.
export function useGameBusValue<K extends keyof GameBusEvents>(
  event: K,
  initial: GameBusEvents[K],
): GameBusEvents[K] {
  const [value, setValue] = useState<GameBusEvents[K]>(initial)
  useEffect(() => {
    const unsub = GameBus.on(event, (payload) => setValue(payload))
    return unsub
  }, [event])
  return value
}
